import pushOptimizelyEvent from 'pathfinder/utils/pushOptimizelyEvent';
export var RISER;
(function (RISER) {
    RISER["DISPLAY_ON_N_PAGEVIEW"] = "discovery_riser_display_on_n_pageview";
    RISER["DISPLAY_AFTER_N_SECONDS"] = "discovery_riser_display_after_n_seconds";
    RISER["VARIANT_NAME"] = "discovery_riser_variant_name";
    RISER["WRAPPER_STYLES"] = "discovery_riser_wrapper_styles";
    RISER["CLOSE_BUTTON_STYLES"] = "discovery_riser_close_button_styles";
    RISER["HEADER_TEXT"] = "discovery_riser_header_text";
    RISER["HEADER_STYLES"] = "discovery_riser_header_styles";
    RISER["IMAGE"] = "discovery_riser_image";
    RISER["IMAGE_STYLES"] = "discovery_riser_image_styles";
    RISER["DESCRIPTION_TEXT"] = "discovery_riser_description_text";
    RISER["DESCRIPTION_STYLES"] = "discovery_riser_description_styles";
    RISER["BUTTON_TEXT"] = "discovery_riser_button_text";
    RISER["BUTTON_LINK"] = "discovery_riser_button_link";
    RISER["BUTTON_STYLES"] = "discovery_riser_button_styles";
})(RISER || (RISER = {}));
export const optimizelyDiscoveryRiserImpression = () => pushOptimizelyEvent('pathfinder_discovery_riser_impression');
export const optimizelyDiscoveryRiserCloseClick = () => pushOptimizelyEvent('pathfinder_discovery_riser_close_click');
export const optimizelyDiscoveryRiserButtonClick = () => pushOptimizelyEvent('pathfinder_discovery_riser_button_click');
